import { useMemo } from "react";
import { useSelector } from "react-redux";
import { IoMdArrowBack } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import { User, Mail, Phone, CalendarDays, ChevronRight } from "lucide-react";

const AccountDetails = () => {
    const navigate = useNavigate();
    const { User_profile } = useSelector((state) => state.AccountProfile);

    const personalDetailsInfo = useMemo(() => [
        { label: "Name", icon: User, value: User_profile?.full_name ?? "—", path: "/settings/account/edit-details" },
        { label: "Email", icon: Mail, value: User_profile?.email ?? "—", path: "/settings/account/email" },
        { label: "Phone Number", icon: Phone, value: User_profile?.phone_number ?? "Enter your phone number", path: "/settings/account/phone-number" },
        { label: "Date of Birth", icon: CalendarDays, value: User_profile?.date_of_birth ?? "—", path: "/settings/account/dob" },
    ], [User_profile]);

    if (!User_profile) {
        return (
            <div className="bg-white dark:bg-[#1E1D21] min-h-screen flex items-center justify-center">
                <p className="text-black dark:text-white text-[14px]">Loading...</p>
            </div>
        );
    }

    return (
        <div className="bg-white dark:bg-[#1E1D21]">
            <div className="sticky top-0 z-50">
                <div className="relative flex items-center justify-center h-12 bg-[#BDE6FF] rounded-b-xl px-2">
                    <IoMdArrowBack
                        onClick={() => navigate("/settings/account")}
                        className="absolute left-2 top-1/2 transition-transform -translate-y-1/2 text-[24px] text-black cursor-pointer"
                    />
                    <p className="text-center font-bold text-[16px] text-black flex-grow">Personal Details</p>
                </div>
            </div>

            <p className="text-[14px] text-black dark:text-white px-3 pt-5 font-bold">Personal Details</p>
            <p className="text-[12px] text-justify text-black dark:text-white px-3 pt-1">
                Your name and personal details help us verify your account and keep it secure.
                This information is kept private and only used for verification purpose.
                You can update your personal details at any time here.
            </p>

            <div className="mx-3 bg-[#BDE6FF] dark:bg-[#333333] rounded-lg mt-5">
                {personalDetailsInfo.map((item) => (
                    <div
                        key={item.label}
                        onClick={() => navigate(item.path)}
                        className="flex items-center justify-between p-4 border-b border-gray-200 dark:border-gray-800/50 last:border-b-0 cursor-pointer"
                    >
                        <div className="flex items-center space-x-3">
                            <item.icon className="w-4 h-4 text-black dark:text-white shrink-0" />
                            <div>
                                <p className="text-[14px] font-bold text-black dark:text-white">{item.label}</p>
                                <p className="text-[12px] text-black dark:text-white">{item.value}</p>
                            </div>
                        </div>
                        <ChevronRight className="w-4 h-4 text-black dark:text-white shrink-0" />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default AccountDetails;